import React, { ReactNode } from 'react';
import { defineMessage } from 'react-intl';
import { Box, LinearProgress } from '@mui/material';

import { NavigationBar, Page, PageContent, SizingMultiplier, PoweredByWatermark } from '@ocx/ui';
import { BackButton } from '@ocx-app/components/Layout/NavigationBar/BackButton/BackButton';
import { HtmlTitle } from '@ocx-app/components/router/HtmlTitle';

type LocalOffersLocationSelectorPageLayoutProps = {
  children: ReactNode;
  isLoading: boolean;
  headerCenter?: ReactNode;
};

export const LocalOffersLocationSelectorPageLayout: React.FC<LocalOffersLocationSelectorPageLayoutProps> = ({
  children,
  isLoading,
  headerCenter,
}) => {
  return (
    <Page>
      <HtmlTitle
        title={defineMessage({
          id: 'localOffersStoreSelector:htmlTitle',
          defaultMessage: 'Local Offers Store Selector',
          description: 'HTML title tag for Local Offers Store Selector Page',
        })}
      />

      <NavigationBar hideRightSection left={<BackButton />} center={headerCenter} />

      <PageContent>
        <Box m={SizingMultiplier.md}>{children}</Box>

        <PoweredByWatermark />
      </PageContent>
      {isLoading && <LinearProgress sx={{ opacity: 0.8 }} />}
    </Page>
  );
};
